import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { TopSellingHeading } from "../../../../utils/Constant";
import TopSellingTable from "./TopSellingTable";

const TopSelling = () => {
  return (
    <Col lg="6">
      <Card className="selling-table">
        <CardHeaderCommon title={TopSellingHeading} />
        <CardBody className="pt-0">
          <TopSellingTable />
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopSelling;
